import React from 'react';
import PropTypes from 'prop-types';
import nouislider from 'nouislider';
import 'nouislider/distribute/nouislider.css';
import './NoUiSlider.scss';

function Slider(props) {
  return <div ref={props.slider} />;
}

class NoUiSlider extends React.Component {
  constructor(props) {
    super(props);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleStart = this.handleStart.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleSlide = this.handleSlide.bind(this);
  }

  componentDidMount() {
    nouislider.create(this.sliderElement, this.props.options);
    this.props.onUpdate && this.sliderElement.noUiSlider.on('update', this.handleUpdate);
    this.props.onChange && this.sliderElement.noUiSlider.on('change', this.handleChange);
    this.props.onStart && this.sliderElement.noUiSlider.on('start', this.handleStart);
    this.props.onEnd && this.sliderElement.noUiSlider.on('end', this.handleEnd);
    this.props.onSlide && this.sliderElement.noUiSlider.on('slide', this.handleSlide);
    const connectClass = this.props.options.connectClass;
    if (connectClass) {
      const connectElements = this.sliderElement.querySelectorAll('.noUi-connect');
      connectElements.forEach((segment, index) => segment.classList.add(connectClass[index]));
    }
  }

  componentWillReceiveProps(nextProps) {
    if ((this.sliderElement || {}).noUiSlider) {
      const current = this.sliderElement.noUiSlider.get();
      const update = Array(current.length).fill(null);
      const custom = typeof current === 'string' ? [current] : current;
      custom.forEach((value, index) => {
        if (value !== nextProps.values[index]) update[index] = nextProps.values[index];
      });
      if (update.some(el => el !== null)) {
        this.sliderElement.noUiSlider.set(update);
      }
    }
  }

  componentWillUnmount() {
    this.sliderElement.noUiSlider.destroy();
  }

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.type !== this.props.type ||
      nextProps.length !== this.props.length ||
      nextProps.radarData !== this.props.radarData
    );
  }

  componentDidUpdate() {
    this.sliderElement.noUiSlider.destroy();
    nouislider.create(this.sliderElement, this.props.options);
    this.props.onUpdate && this.sliderElement.noUiSlider.on('update', this.handleUpdate);
    this.props.onChange && this.sliderElement.noUiSlider.on('change', this.handleChange);
    this.props.onStart && this.sliderElement.noUiSlider.on('start', this.handleStart);
    this.props.onEnd && this.sliderElement.noUiSlider.on('end', this.handleEnd);
    this.props.onSlide && this.sliderElement.noUiSlider.on('slide', this.handleSlide);
  }

  handleUpdate(newValues) {
    this.props.onUpdate(newValues);
  }

  handleChange(newValues) {
    this.props.onChange(newValues);
  }

  handleStart(newValues) {
    this.props.onStart(newValues);
  }

  handleEnd(newValues) {
    this.props.onEnd(newValues);
  }

  handleSlide(newValues) {
    this.props.onSlide(newValues);
  }

  render() {
    return <Slider slider={el => (this.sliderElement = el)} />;
  }
}

NoUiSlider.propTypes = {
  values: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired
};

Slider.propTypes = {
  slider: PropTypes.func.isRequired
};

export default NoUiSlider;
